module.exports = __webpack_public_path__ + "img/close-m.b77ee9c5.svg";